import AboutUsLogo from 'images/logo/IE-logo-2.png'

export const aboutUsContent = (
    <>
        <div className='flex justify-center'><img src={AboutUsLogo} alt='IE Logo' /></div>

        <div className='py-8 space-y-4'>
            <div className='font-bold text-xl'>
                Our mission is to provide true affordable health
                insurance to qualified individual, family, and small businesses.
            </div>

            <div className='text-base space-y-4'>
                <div>
                    We are licensed in 34 states and have been helping thousands of Americans since 2015.
                    We work with top health insurance companies such as Aetna, UnitedHealthcare, Cigna, and many more.
                    We are committed to educating our consumers and offering them
                    affordable insurance solutions – keeping their insurance premiums stable and as low as possible.
                </div>
                <div>
                    We are also devoted to superior customer service. When you call us, you will talk to a live person…
                    a person who cares about you, your family, and your employees.
                </div>
                <div>
                    At Insurance Enterprise, we can help you get the insurance coverage you need whenever and however you want to shop for it:
                </div>
                <div>
                    Phone – Over the phone personalized assistance is available allowing you to get enrolled when it is most convenient for you
                    <br />
                    Online – You can request a quote anytime online and one of our agents will be in touch with you
                </div>
                <div>
                    We are here to help you take control of your health care future.
                </div>
            </div>

        </div>
    </>
)